import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import '../../stylesheets/CustomAlert.css';
import FormSelect from './FormSelect';
import { UserManagementAPI } from '../../axios';

// Define validation schema using Yup
const EditUserSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  // password: Yup.string().required('Password is required'),
  role: Yup.string().required('Role is required'),
  location: Yup.array().min(1, 'At least one country is required').required('Country is required'),
});

const EditUser = ({ userId, onCancel, onSubmit }) => {
  const [adminUser, setAdminUser] = useState([]);
  const [roleNames, setRoleNames] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    // Fetch the admin user data
    UserManagementAPI.fetch_admin_user(userId)
      .then((res) => {
        if (res.code === 200) {
          setAdminUser(res.data.adminUser);
          setRoleNames(res.data.roleNamesArray);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // Initialize country list
    setCountries(countryList().getData());
  }, [userId]);

  const handleSubmit = (values) => {
    UserManagementAPI.edit_admin_user(adminUser?._id, JSON.stringify(values))
      .then((res) => {
        console.log('Edit successful');
        onSubmit();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="custom-alert-overlay">
      <div className="custom-alert-edit">
        <button className="custom-alert-close" onClick={onCancel}>×</button>
        <div className='heading'>
          <span>Edit User</span>
        </div>
        <Formik
          initialValues={{
            name: adminUser.name || '',
            email: adminUser.email || '',
            // password: adminUser.password || '',
            role: selectedRole ? selectedRole : roleNames.length > 0 ? roleNames[0] : 'Admin',
            location: adminUser.location || [],
          }}
          validationSchema={EditUserSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values }) => (
            <Form className="inputs-edit">
              <span className='label'>Name</span>
              <div className="input-edit">
                <Field type="text" name="name" placeholder="Enter name" />
              </div>
              <ErrorMessage name="name" component="div" className="error" />
              <span className='label'>Email</span>
              <div className="input-edit">
                <Field type="email" name="email" placeholder="Enter email" />
              </div>
              <ErrorMessage name="email" component="div" className="error" />
              {/* <span className='label'>Password</span>
              <div className="input-edit">
                <Field type="password" name="password" placeholder="Enter password" />
              </div> */}
              <ErrorMessage name="password" component="div" className="error" />
              <span className='label'>Roles</span>
              <FormSelect
                name="role"
                options={roleNames}
              />
              <ErrorMessage name="role" component="div" className="error" />
              <span className='label'>Countries</span>
              <Select
                name="location"
                options={countries}
                isMulti
                value={countries.filter(option => values.location.includes(option.label))}
                onChange={(selectedOptions) => {
                  const selectedCountries = selectedOptions ? selectedOptions.map(option => option.label) : [];
                  setFieldValue("location", selectedCountries);
                }}
                className="react-select-container"
                classNamePrefix="react-select"
              />
              <ErrorMessage name="location" component="div" className="error" />
              <button type="submit" className="edit-save-button">Save</button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EditUser;
